import _axios from "@/plugins/axios";
export const TabSix = {
    state: {
        revenue: []
    },
    getters: {
        getBranchRevenueTabSix(state) {
            return state.revenue;
        },
    },
    mutations: {
        setBranchRevenueTabSix(state, data) {
            state.revenue = data;
        }
    },
    actions: {
        fetchBranchRevenueTabSix({commit}, payload) {
            _axios.get('/api/v1/reports/dashboard/tab-six', {
                params: {
                    start_date: payload.start,
                    end_date: payload.end
                }
            }).then(response => {
                commit('setBranchRevenueTabSix', response.data);
            });
        }
    },
}
